import classNames from 'classnames';
import Image from 'next/image';
import { FC } from 'react';
import Button from '../Button';
import styles from './SocialButtons.module.scss';

import Link from 'next/link';
import { GOOGLE_SIGN_IN_URL } from './variables';

interface GoogleButtonProps {
    appId: string;
    title?: string;
}

const GoogleButton: FC<GoogleButtonProps> = ({ appId, title = 'Google' }) => {
    return (
        <Link href={GOOGLE_SIGN_IN_URL(appId)} className="w-full">
            <Button className={classNames(styles.social_btn, styles.google_btn)}>
                <Image alt="Google's logo" src="/svgs/google.svg" width={20} height={20} />
                {title}
            </Button>
        </Link>
    );
};

export default GoogleButton;
